import {
  Box,
  IconButton,
} from '@mui/material';
import {styled} from '@mui/system';

export const DatesWindowContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  paddingTop: '14px',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
    borderRadius: '0.75rem',
  },
}));

export const NavButton = styled(IconButton)(({theme}) => ({
  'fontWeight': 'bolder',
  'height': '40px',
  'width': '40px',
  'borderRadius': '25%',
  'marginTop': '5px',
  'color': theme.palette.text.primary,
  '&:hover': {
    background: theme.palette.background.hover,
  },
  '&:active': {
    background: theme.palette.background.active,
  },
  '&.Mui-disabled': {
    color: theme.palette.common.swatch['40'],
  },
  '&.Mui-focusVisible': {
    boxShadow: `0px 0px 0px 2px ${theme.palette.common.white}, 0px 0px 0px 4px ${theme.palette.primary.swatch['60']}`,
  },
  [theme.breakpoints.up('sm')]: {
    'border': `1px solid ${theme.palette.common.swatch[30]}`,
    'marginTop': '18px',
  },
  [theme.breakpoints.down('sm')]: {
    'marginLeft': '-40px',
    'marginRight': '-40px',
  },
}));
